import { Container } from "react-bootstrap";
import React, { useEffect, useState } from "react";
// import handleViewport from "react-in-viewport";

import styles from "./style.module.scss";
import CoreServiceWeb from "./CoreServiceWeb";
import CoreServiceMobile from "./CoreServiceMobile";

const CoreService = (props) => {
    const { block } = props;
    const inViewport = true;
    // const { forwardedRef, inViewport, data } = props;
    const [isDesktopView, setIsDesktopView] = useState(true);


    useEffect(() => {
        const setView = () => {
            if (window?.innerWidth > 767) {
                setIsDesktopView(true);
            } else {
                setIsDesktopView(false);
            }
        };
        setView();

        window.addEventListener("resize", setView);
        return () => {
            window.addEventListener("resize", setView);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <section
            className={`${styles["core-service-section"]} core-service-section bg-one home-padding-new`}
        >
            {inViewport && (
                <div className={styles["industry-new-inner"]}>
                    <Container className={styles["container"]}>

                        {isDesktopView ? (
                            <CoreServiceWeb block={block} />
                        ) : (
                            <CoreServiceMobile data={block} />
                        )}
                    </Container>
                </div>
            )}
        </section>
    );
};

// const IndustryViewportBlock = handleViewport(Industry);

export default CoreService;
